export const MY_TAX_ACCESS_QR_SRC = '/assets/img/rocketwork/my-tax-access-qr.png';

export const MY_TAX_ACCESS_QR_CAPTION = 'Отсканируйте QR-код на телефоне, чтобы открыть приложение';
